import Prism from 'prismjs';
Prism.hooks.add('before-sanity-check', (env) => {
  env.code = env.element.textContent;
});
var HTMLFormatter = require('html-formatter');
var JSFormatter = require('js-beautify').js;
var normalizer = require('prismjs/plugins/normalize-whitespace/prism-normalize-whitespace');
import codeBlocks from '../codeBlocks.js';

window.addEventListener('load', ()=>{

	const codeBlocksArr = [];

	[...document.querySelectorAll('.code-block')].map((cb)=>{
		let toCopy;
		// code blocks from js file
		if(cb.hasAttribute('codeblock'))
		{
			let id = cb.getAttribute('data-code-block-id');
			let rdm = cb.hasAttribute('data-code-block-rootDataModifiers') ? cb.getAttribute('data-code-block-rootDataModifiers') : null;
			let rcm = cb.hasAttribute('data-code-block-rootClassModifiers') ? cb.getAttribute('data-code-block-rootClassModifiers') : null;
			if(!codeBlocks[id]){console.log(`No Code Block entry found with id: ${id}`);return;}
			toCopy = HTMLFormatter.render(codeBlocks[id](rdm, rcm));
			cb.querySelector('code').textContent = toCopy;
			codeBlocksArr.push(cb);
		}
		//code blocks which are just static text
		else
		{
			let code = cb.querySelector('code');
			let it = code.textContent;
			toCopy = JSFormatter(it,{brace_style:"collapse,preserve-inline"});
			code.textContent = toCopy; 
		}

		cb.addEventListener("click", ()=>{
			copyToClipboard(toCopy);
		  cb.classList.add('copied');
		  setTimeout(()=>{cb.classList.remove("copied")}, 5000);
		});

		if(cb.hasAttribute('codeblock')) {
			window.requestAnimationFrame(()=>{cb.classList.add('notactive')})
		}

		return;
	});

	Prism.highlightAll();

	const codeBlockIcon = document.getElementById('code-block-icon');
	codeBlockIcon && codeBlockIcon.addEventListener('click', ()=>{openCodeBlocks();});

	let openCodeBlocksElements = [...document.querySelectorAll('.open-code-block')];
	openCodeBlocksElements.map((el)=>{
		el.addEventListener('click', (e)=>{
			e.preventDefault();
			openCodeBlocks(true);
			let cbid = el.getAttribute('data-open-code-block');
			if(cbid)
			{
				document.querySelector(`.code-block[data-code-block-id='${cbid}']`).scrollIntoView();
			}
		})
		return;
	})

	function openCodeBlocks(force=false)
	{
		if(force)
		{
			codeBlocksArr.map((cb)=>cb.classList.remove('notactive'));
			codeBlockIcon.classList.add('active');
			return;
		}
		codeBlocksArr.map((cb)=>cb.classList.toggle('notactive'));
		codeBlockIcon.classList.toggle('active');		
	}
})